/* eslint-disable no-unused-vars */
import Vue from 'vue';
const $vm = Vue.prototype;

class BaseService {
    constructor(resource) {
        if (!resource) throw new Error('Path not provided');
        // this.baseUrl = 'api/v1/';
        // this.path = this.baseUrl + resource;
        this.path = resource; 
    }

    errorHandler(data) {
        return data;
    }

    url({ id }) {
        const path = this.path;
        return id ? path.concat('/', id) : path;
    }
}

class ReadOnlyService extends BaseService {
    constructor(resource) {
        super(resource)
    }

    async get({ 
        id = '', 
        params = {} 
    } = {}) {
        try {
            const url = this.url({ id });
            const { data } = await $vm.$http(url, {params: {...params}});
            return { data }; 
        } catch (error) {
            this.errorHandler(error.response.data);
        }
    }
}

class ModelService extends BaseService {
    constructor(resource) {
        super(resource)
    }
    
    async post({ 
        method = 'POST', 
        headers, 
        id = '', 
        body = {} 
    } = {}) {
        try {
            const url = this.url({ id });
            const { data } = await $vm.$http(url, {
                method: method,
                data: body,
                headers: headers,
            })

            return { data };
        } catch (error) {
            const payload = error && error.response && error.response.data;
            if (payload) {
                return { data: payload };
            }
            return { data: null };
        }
    }
}

class PatchService extends BaseService {
    constructor(resource) {
        super(resource)
    }
    
    async patch({ 
        method = 'PATCH', 
        headers, 
        id = '', 
        body = {} 
    } = {}) {
        try {
            const url = this.url({ id });
            
            const { data } = await $vm.$http(url, {
                method: method,
                data: body,
                headers: {...headers},
            })

            return { data };
        } catch (error) {
            this.errorHandler(error.response.data);
        }
    }
}

class DeleteService extends BaseService {
    constructor(resource) {
        super(resource)
    }
    
    async delete({ 
        method = 'DELETE', 
        id = '', 
        body = {}
    } = {}) {
        try {
            const url = this.url({ id });
            
            const { data } = await $vm.$http(url, {
                method: method,
                data: body,
            })

            return { data };
        } catch (error) {
            this.errorHandler(error.response.data);
        }
    }
}

// Authorization

class Login extends ModelService {
    constructor() {
        super('users/login')
    }
}
class AdminLogin extends ModelService {
    constructor() {
        super('users/admin-login')
    }
}
class Logout extends ModelService {
    constructor() {
        super('users/logout')
    }
}
class PasswordRecovery extends ModelService {
    constructor() {
        super('users/password-recovery')
    }

    recover({ email }) {
        return this.post({ method: 'PATCH', body: { email } })
    }
}

class PingAuth extends ReadOnlyService {
    constructor() {
        super('auth/ping')
    }
}

class PingAccess extends ReadOnlyService {
    constructor() {
        super('auth/access')
    }
}

//Users
class GetUsers extends ReadOnlyService {
    constructor() {
        super('users/collection')
    }
}

class GetUser extends ReadOnlyService {
    constructor() {
        super('users/user')
    }
}

class AddUser extends ModelService {
    constructor() {
        super('users/add')
    }
}

class EditUser extends PatchService {
    constructor() {
        super('users/edit')
    }
}

class DeleteUser extends DeleteService {
    constructor() {
        super('users/remove')
    }
}

class FindUser extends ReadOnlyService {
    constructor() {
        super('users/find')
    }
}

// Files

class GetFiles extends ReadOnlyService {
    constructor() {
        super('files/get-details')
    }
}

class PostFiles extends ModelService {
    constructor() {
        super('files/add-file')
    }
}

class PostFileDetails extends ModelService {
    constructor() {
        super('files/add-details')
    }
}

class EditFile extends PatchService {
    constructor() {
        super('files/edit')
    }
}

class DeleteFile extends DeleteService {
    constructor() {
        super('files/remove')
    }
}

//Recipients
class GetRecipients extends ReadOnlyService {
    constructor() {
        super('recipients/collection')
    }
}

class GetRecipient extends ReadOnlyService {
    constructor() {
        super('recipients/recipient')
    }
}

class FindRecipient extends ReadOnlyService {
    constructor() {
        super('recipients/find')
    }
}

class AddRecipient extends ModelService {
    constructor() {
        super('recipients/add')
    }
}

class AddRecipientProfile extends ModelService {
    constructor() {
        super('recipients-profiles/add')
    }
}

class EditRecipient extends PatchService {
    constructor() {
        super('recipients/edit')
    }

    async update({ id, body }) {
        try {
            const { data } = await $vm.$http(this.url({ id }), {
                method: 'PATCH',
                data: body,
            })
            return { data }
        } catch (error) {
            const payload = error && error.response && error.response.data
            return { data: payload || null }
        }
    }
}

class EditRecipientProfile extends PatchService {
    constructor() {
        super('recipients-profiles/edit')
    }
}

class DeleteRecipient extends DeleteService {
    constructor() {
        super('recipients/remove')
    }
}
//Promotions
class GetPromotions extends ReadOnlyService {
    constructor() {
        super('promotions/collection')
    }
}

class AddPromotion extends ModelService {
    constructor() {
        super('promotions/add')
    }
}

class EditPromotion extends ModelService {
    constructor() {
        super('promotions/edit')
    }

    update({ id, body }) {
        return this.post({ method: 'PATCH', id, body })
    }
}

class DeletePromotion extends ModelService {
    constructor() {
        super('promotions/remove')
    }

    remove({ id }) {
        return this.post({ method: 'DELETE', body: { id } })
    }
}

//SMS
class GetSMSStatus extends ReadOnlyService {
    constructor() {
        super('sms/status')
    }
}

class GetSMSBalance extends ReadOnlyService {
    constructor() {
        super('sms/balance')
    }
}

class GetSMSSenders extends ReadOnlyService {
    constructor() {
        super('sms/senders')
    }
}

class SendSMS extends ReadOnlyService {
    constructor() {
        super('sms/send')
    }
}

export const $api = {
    login: new Login(),
    adminLogin: new AdminLogin(),
    logout: new Logout(),
    passwordRecovery: new PasswordRecovery(),
    PingAuth: new PingAuth(),
    pingAccess: new PingAccess(),
    getUsers: new GetUsers(),
    getUser: new GetUser(),
    findUser: new FindUser(),
    addUser: new AddUser(),
    editUser: new EditUser(),
    deleteUser: new DeleteUser(),
    getFiles: new GetFiles(),
    editFile: new EditFile(),
    addFile: new PostFiles(),
    addFileDetails: new PostFileDetails(),
    deleteFile: new DeleteFile(),
    getRecipients: new GetRecipients(),
    getRecipient: new GetRecipient(),
    findRecipient: new FindRecipient(),
    addRecipient: new AddRecipient(),
    addRecipientProfile: new AddRecipientProfile(),
    editRecipient: new EditRecipient(),
    editRecipientProfile: new EditRecipientProfile(),
    deleteRecipient: new DeleteRecipient(),
    getPromotions: new GetPromotions(),
    addPromotion: new AddPromotion(),
    editPromotion: new EditPromotion(),
    deletePromotion: new DeletePromotion(),
    getSMSStatus: new GetSMSStatus(),
    getSMSBalance: new GetSMSBalance(),
    getSMSSenders: new GetSMSSenders(),
    sendSMS: new SendSMS(),
}